<template>
    <div>
        <div
            class="hts-form-disclosure rounded-lg"
            :class="cClass"
            @click="handleClick">
            <div
                class="hts-form-disclosure__reference"
                :class="{ open: open }"
                @click="handleOpen">
                <slot name="reference" />
                <div class="flex">
                    <hi-chevron-right-icon
                        v-if="props.isHaveChildren"
                        class="hts-form-disclosure__reference-icon"
                        :class="[open && 'rotate-90']"
                        aria-hidden="true" />
                    <div class="flex">
                        <hi-x-mark-icon
                            v-if="props.isHaveRemoveIcon && !props.disabled"
                            class="hts-form-disclosure__reference-icon"
                            aria-hidden="true"
                            @click="handleRemove" />
                        <hi-pencil-icon
                            v-if="props.isEdit && !props.disabled"
                            class="hts-form-disclosure__reference-icon"
                            aria-hidden="true"
                            @click="handleEdit" />
                    </div>
                </div>
                <slot name="footer" />
            </div>
        </div>
        <div
            class="hts-form-disclosure__container"
            :class="{ open: open }">
            <slot name="children" />
        </div>
    </div>
</template>

<script setup lang="ts">
import colorSize from '~/components/color-size'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  color: {
    type: String,
    default: ''
  },
  size: {
    type: String,
    default: ''
  },
  isHaveChildren: {
    type: Boolean,
    default: false
  },
  isHaveRemoveIcon: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  isEdit: {
    type: Boolean,
    default: false
  }
})
const { cClass } = colorSize(props)
const emits = defineEmits(['click', 'remove', 'edit'])
const open = ref(false)
const handleOpen = () => {
  open.value = !open.value
}
const handleClick = () => {
  emits('click')
}
const handleRemove = () => {
  emits('remove')
}
const handleEdit = () => {
  emits('edit')
}

const expand = () => {
  open.value = true
}

const collapse = () => {
  open.value = false
}

defineExpose({
  expand,
  collapse
})
</script>
